import { useLabelVersion } from '../../../features/labels/LabelsProvider';
import { labelId, labelRegion, labelArea, labelCentro } from '../../../features/labels/labels';
﻿import React, { useCallback, useEffect, useMemo, useState, startTransition } from "react";
import {
  Box,
  Collapse,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";
import { FEEDING_RATES, availableRateKeys } from "../utils/feedingRates";
import LogoItg from "../../../assets/img/ITG_BLANCO.png";
import LanguageSelector from "../../../components/LanguageSelector";
import TemporaryDrawer from "./Drawer/TemporaryDrawer";
import SelectorData from "./SelectorData";
import "./utils/VersusAppbar.css";
import Logo from "./utils/logo_scapp_blanco.png";
import LastMeasurement from "./utils/LastMeasurement";
import { CalendarioAnalitica } from "./Calendario";
import HoverCards from "./HoverCards";
import DepthAnalyticsDialog from "./DepthAnalytics/DepthAnalyticsDialog";
import { listDepthCages } from "./DepthAnalytics/depthAnalytics";
import { findScappSelectionLabel } from "../utils/compareSelection";
import {
  buildNotesByJaulaDay,
  normalizeNoteDayKey,
} from "./Charts/LineChart/TasaChart";
import CompareArrowsRoundedIcon from "@mui/icons-material/CompareArrowsRounded";
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import SplitscreenRoundedIcon from "@mui/icons-material/SplitscreenRounded";
import HeightRoundedIcon from "@mui/icons-material/HeightRounded";
import ViewCompactRoundedIcon from "@mui/icons-material/ViewCompactRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import SetMealRoundedIcon from "@mui/icons-material/SetMealRounded";
import NotificationImportantRoundedIcon from "@mui/icons-material/NotificationImportantRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { canViewFeederScore, normalizeSuperuserCargo } from "../../../features/ai-usage/aiUsageClient";
import { SW_VERSION } from "../../../version";

const EMPTY_NOTES = [];
const EMPTY_ANALYTICS = {};

const ScappAppbar = ({
  capitalize,
  translate,
  idioma,
  handleToggle,
  view,
  setView,
  setViewMode,
  permisosCentros,
  dias,
  setDias,
  versus,
  setVersus,
  data,
  regionSeleccionada,
  setRegionSeleccionada,
  areaSeleccionada,
  setAreaSeleccionada,
  centroSeleccionado,
  setCentroSeleccionado,
  selectedCenters,
  setSelectedCenters,
  selectedDay,
  setSelectedDay,
  jaulaSeleccionada,
  viewMode,
  fastingResolution,
  setFastingResolution,
  selectedRateKey,
  setSelectedRateKey,
  showRateToggle = false,
  isComparisonView = false,
  nivelSeleccionado,
  setNivelSeleccionado,
  nameVista,
  permisosJaula,
  ultimaHora,
  onCompactClick,
  compact,
  simpleView,
  setSimpleView,
  setGroupMode,
  groupMode,
  xlsxExport,
}) => {
  useLabelVersion();
  const t = (key, fallback, params) => {
    const value = typeof translate === "function" ? translate(key, params) : key;
    return value && value !== key ? value : fallback;
  };

  const [rangosOpen, setRangosOpen] = useState(false);
  const [depthAnalyticsOpen, setDepthAnalyticsOpen] = useState(false);
  const [open, setOpen] = useState(true);
  const [vsOpen, setVSOpen] = useState(false);
  const availableRates = useMemo(() => availableRateKeys(Object.values(data?.analytic_data || {})), [data]);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [settingsDrawerOpen, setSettingsDrawerOpen] = useState(false);
  const [openGroups, setOpenGroups] = useState({
    analitica: true,
    metricas: true,
    tiempo: true,
  });
  const cargo = localStorage.getItem("cargo");
  const isSuperuser = normalizeSuperuserCargo(cargo);
  const feederScoreAllowed = canViewFeederScore(cargo);
  const depthCages = useMemo(
    () => nivelSeleccionado === "centro"
      ? listDepthCages(Object.values(data?.analytic_data || EMPTY_ANALYTICS))
      : [],
    [data?.analytic_data, nivelSeleccionado],
  );
  const hasDepthData = depthCages.length > 0;
  const notes = useMemo(
    () => (
      isComparisonView && nivelSeleccionado !== "centro" && Array.isArray(versus)
        ? versus.flatMap((item) => item?.notes || EMPTY_NOTES)
        : data?.notes || EMPTY_NOTES
    ),
    [data?.notes, isComparisonView, nivelSeleccionado, versus],
  );
  const notesByJaulaDay = useMemo(
    () => buildNotesByJaulaDay(notes, data?.analytic_data || EMPTY_ANALYTICS, compact),
    [compact, data?.analytic_data, notes],
  );
  const calendarNotesByDay = useMemo(() => {
    const source = nivelSeleccionado === "centro" && jaulaSeleccionada
      ? Object.values(notesByJaulaDay[jaulaSeleccionada] || {}).flat()
      : notes;

    return source.reduce((index, note) => {
      const day = normalizeNoteDayKey(note.timestamp);
      if (!day) return index;
      index[day] ??= [];
      const noteId = note.note_id || note._id;
      if (!index[day].some((item) => (item.note_id || item._id) === noteId)) {
        index[day].push(note);
      }
      return index;
    }, {});
  }, [jaulaSeleccionada, nivelSeleccionado, notes, notesByJaulaDay]);

  const toggleRangos = () => setRangosOpen((prev) => !prev);
  const toggleGroup = (key) =>
    setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
  const toggleDrawer = (newOpen) => () => setOpen(newOpen);
  const handleOpen = () => setVSOpen(true);
  const handleClose = () => setVSOpen(false);
  const handleCalendarOpen = () => setCalendarOpen(true);
  const handleCalendarClose = () => setCalendarOpen(false);
  const handleSettingsDrawerOpen = () => setSettingsDrawerOpen(true);
  const handleSettingsDrawerClose = () => setSettingsDrawerOpen(false);
  const handleSettingsAction = (handler) => (event) => {
    if (typeof handler === "function") handler(event);
    setSettingsDrawerOpen(false);
  };
  const handleFastingResolutionChange = useCallback(
    (event) => {
      const nextValue = event.target.value;
      startTransition(() => {
        setFastingResolution(nextValue);
      });
    },
    [setFastingResolution]
  );
  const handleLogoMouseEnter = () => setOpen(true);
  const handleLogoMouseLeave = () => setOpen(false);

  const handleChange = (event) => {
    const raw = event.target.value;
    const newSelection = typeof raw === "string" ? raw.split(",") : raw;
    setSelectedCenters(newSelection);
  };

  useEffect(() => {
    const shouldOpen = view === "versus" && nivelSeleccionado === "centro";

    setVSOpen(shouldOpen);
  }, [view, nivelSeleccionado]);

  useEffect(() => {
    if (view === "versus" && nivelSeleccionado !== "centro") {
      setView("dashboard");
    }
  }, [nivelSeleccionado, setView, view]);

  useEffect(() => {
    if ((view === "feederScore" || view === "alarmAttention") && !feederScoreAllowed) {
      setView("dashboard");
    }
  }, [feederScoreAllowed, setView, view]);

  useEffect(() => {
    if (view === "insight" && !isSuperuser) {
      setView("dashboard");
    }
  }, [isSuperuser, setView, view]);

  const drawerProps = {
    SWVersion: SW_VERSION,
    translate,
    capitalize,
    setViewMode,
    open,
    setOpen,
    toggleDrawer,
    handleLogoMouseEnter,
    handleLogoMouseLeave,
    permisosCentros,
    regionSeleccionada,
    setRegionSeleccionada,
    areaSeleccionada,
    setAreaSeleccionada,
    centroSeleccionado,
    setCentroSeleccionado,
    selectedCenters,
    setSelectedCenters,
    nivelSeleccionado,
    setNivelSeleccionado,
  };

  const hoverCardsProps = {
    data: data?.analytic_data,
    selectedDay,
    selectedCage: jaulaSeleccionada,
    viewMode,
    nivelSeleccionado,
    translate,
  };

  const selectorDataProps = {
    translate,
    permisosCentros,
    isOpen: vsOpen,
    closeDrawer: handleClose,
    selectedCenters,
    handleChange,
    dias,
    versus,
    setVersus,
    setSelectedCenters,
    permisosJaula,
    nivelSeleccionado,
  };

  const formatDate = (fecha) => {
    if (!fecha) return "";
    const [day, month, year] = fecha.split("-");
    const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
    return parsedDate.toLocaleDateString(idioma || "es", {
      day: "numeric",
      month: "long",
    });
  };

  const selectedCenterLabels = useMemo(() => {
    const currentSelection = Array.isArray(selectedCenters) ? selectedCenters : [];

    if (nivelSeleccionado !== "centro") {
      return currentSelection;
    }

    return currentSelection.map((selectedValue) =>
      findScappSelectionLabel(selectedValue, permisosJaula ?? [], nivelSeleccionado)
    );
  }, [nivelSeleccionado, permisosJaula, selectedCenters]);

  const compareCount = Array.isArray(selectedCenters) ? selectedCenters.length : 0;
  const rankingAvailableDays = useMemo(() => {
    const days = new Set();

    const collectDays = (node) => {
      if (!node) return;

      if (Array.isArray(node)) {
        node.forEach((item) => collectDays(item));
        return;
      }

      if (typeof node !== "object") return;

      const valuesSummary = node.values_summary;
      if (Array.isArray(valuesSummary)) {
        valuesSummary.forEach((item) => {
          if (item?.day) days.add(item.day);
        });
      } else if (valuesSummary && typeof valuesSummary === "object") {
        Object.keys(valuesSummary).forEach((day) => days.add(day));
      }

      Object.values(node).forEach((value) => collectDays(value));
    };

    collectDays(data?.analytic_data);

    return [...days].sort((a, b) => new Date(b) - new Date(a));
  }, [data]);
  const rankingPeriodValue = viewMode === "day" && selectedDay ? selectedDay : "all";
  const versusScaleClass =
    selectedCenterLabels.length >= 4
      ? "versus-scale-4"
      : selectedCenterLabels.length === 3
        ? "versus-scale-3"
        : "";
  const handleGroupModeChange = useCallback(
    (nextMode) => {
      if (groupMode === nextMode) return;
      startTransition(() => {
        setGroupMode(nextMode);
      });
    },
    [groupMode, setGroupMode]
  );
  const handleRankingPeriodSelect = useCallback(
    (event) => {
      const nextValue = event.target.value;

      startTransition(() => {
        if (nextValue === "all") {
          setSelectedDay(null);
          setViewMode("week");
          return;
        }

        setSelectedDay(nextValue);
        setViewMode("day");
      });
    },
    [setSelectedDay, setViewMode]
  );
  const groupHeaderSx = {
    justifyContent: "space-between",
    minHeight: 34,
    px: 2,
    py: 0.5,
    color: "#e84e0e !important", //"rgba(255, 255, 255, 0.62)",
    "& .MuiListItemText-primary": {
      fontSize: "0.72rem",
      fontWeight: 700,
      letterSpacing: "0.08em",
      lineHeight: 1.6,
      textTransform: "uppercase",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1rem",
    },
  };
  const renderGroupHeader = (key, label) => (
    <ListItemButton
      onClick={() => toggleGroup(key)}
      sx={groupHeaderSx}
      aria-expanded={openGroups[key]}
      aria-label={label}
    >
      <ListItemText primary={label} />
      {openGroups[key] ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
    </ListItemButton>
  );

  return (
    <>
      <header className="appbar">
        <div className="appbar-left">
          <button
            type="button"
            className="appbar-logo-trigger"
            onClick={toggleDrawer(true)}
            onMouseEnter={handleLogoMouseEnter}
            onMouseLeave={handleLogoMouseLeave}
            aria-label={t("menu", "MenÃº")}
          >
            <img src={LogoItg} alt="Logo ITG" className="img-logo-itg" />
          </button>

          <LanguageSelector
            translate={translate}
            sx={{ marginRight: "-2.5vw", minWidth: { xs: "3.3rem", sm: "10.5rem" } }}
          />
        </div>

        <div className="appbar-center">
          {view === "versus" ? (
            <div className="versus-container">
              <div className={`versus-image-container ${versusScaleClass}`.trim()}>
                {selectedCenterLabels.map((center, index) => (
                  <React.Fragment key={`${center}-${index}`}>
                    <div className="vi-card" title={labelId(center, nivelSeleccionado === 'region' ? 'ra' : 'rac', capitalize(center))}>
                      {labelId(center, nivelSeleccionado === 'region' ? 'ra' : 'rac', capitalize(center))}
                    </div>
                    {index < selectedCenterLabels.length - 1 && (
                      <div className="vi-vs-ribbon">{t("versus_short", "V/S")}</div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ) : (
            <div className="name-container">
              <span className="center-name">{capitalize(nivelSeleccionado)}</span>
              <span className="center-name">- {nivelSeleccionado === 'region' ? labelRegion(regionSeleccionada, capitalize(nameVista)) : nivelSeleccionado === 'area' ? labelArea({ region: regionSeleccionada, area: areaSeleccionada }, capitalize(nameVista)) : labelCentro({ region: regionSeleccionada, area: areaSeleccionada, centro: centroSeleccionado }, capitalize(nameVista))}</span>
            </div>
          )}
          <div className="rango-dias">
            {/* {t("temporal_range", "Rango temporal")}: {formatDate(dias.startDate)} {t("to", "to")}{" "} */}
            {dias.dayRange > 1 ? 
            (
              <>
                {formatDate(dias.startDate)} - {formatDate(dias.endDate)}, {dias.dayRange} {t("days", "Days").toLowerCase()} 
              </>
              )
              : <> {formatDate(dias.startDate)} </>
            }

          </div>
        </div>

        <div className="appbar-right">
          <div className="scapp-toolbar">
            <Tooltip title={t("settings", "Configuración")}>
              <IconButton
                type="button"
                className="scapp-icon-button"
                onClick={handleSettingsDrawerOpen}
                aria-label={t("settings", "Configuración")}
                size="small"
              >
                <SettingsRoundedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title={xlsxExport && (!xlsxExport.disabled || xlsxExport.loading)
              ? t("export_format_excel", "Excel")
              : t("export_nothing_to_export", "Sin datos para exportar")}>
              <span>
                <IconButton
                  type="button"
                  className="scapp-icon-button"
                  onClick={xlsxExport?.run}
                  aria-label={t("generate_excel", "Generar Excel")}
                  size="small"
                  disabled={!xlsxExport || xlsxExport.disabled}
                >
                  {xlsxExport?.loading
                    ? <CircularProgress size="1.1em" thickness={5} sx={{ color: "#e84e0e" }} />
                    : <DownloadRoundedIcon fontSize="inherit" />}
                </IconButton>
              </span>
            </Tooltip>
          </div>

          {/* {nivelSeleccionado === "centro" &&  ( */}
            <LastMeasurement
              ultimaHora={ultimaHora}
              translate={translate}
              idioma={idioma}
              nameVista={nameVista}
              regionSeleccionada={regionSeleccionada}
              areaSeleccionada={areaSeleccionada}
              centroSeleccionado={centroSeleccionado}
            />
          {/* )} */}

          <div className="appbar-logo appbar-logo-secondary">
            <img src={Logo} alt="Logo Scapp" className="img-logo-scapp" />
          </div>
        </div>
      </header>

      {view === "dashboard" && <HoverCards {...hoverCardsProps} open={rangosOpen} />}

      <Modal open={calendarOpen} onClose={handleCalendarClose} aria-labelledby="calendar-modal">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "min(68vw, calc(100vw - 3rem))",
            maxWidth: "68vw",
            maxHeight: "88vh",
            overflow: "hidden",
            borderRadius: "1.1vw",
            border: "0.01vw solid rgba(232, 78, 14, 0.28)",
            background:
              "radial-gradient(circle at top right, rgba(232, 78, 14, 0.08), transparent 26%), linear-gradient(180deg, rgba(10, 18, 31, 0.98), rgba(6, 11, 20, 0.98))",
            boxShadow: "0 1.2vw 3vw rgba(0, 0, 0, 0.42)",
            px: "1.2vw",
            py: "1.4vh",
            display: "flex",
            flexDirection: "column",
            gap: "1.1vh",
          }}
        >
          <h3
            style={{
              textAlign: "center",
              margin: 0,
              fontSize: "1.35vw",
              fontWeight: 700,
              color: "#f3f5f8",
              letterSpacing: "0.01em",
            }}
          >
            {translate("select_date")}
          </h3>
          <Box
            sx={{
              width: "100%",
              maxHeight: "calc(88vh - 5.2vh)",
              overflowY: "auto",
              overflowX: "hidden",
              pr: "0.15vw",
            }}
          >
            <CalendarioAnalitica
              dias={dias}
              setDias={setDias}
              translate={translate}
              notesByDay={calendarNotesByDay}
              showNoteSource={nivelSeleccionado !== "centro" || isComparisonView}
            />
          </Box>
        </Box>
      </Modal>

      <Drawer
        anchor="right"
        open={settingsDrawerOpen}
        onClose={handleSettingsDrawerClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: "min(20rem, 88vw)",
            background:
              "linear-gradient(180deg, rgba(10, 18, 31, 0.98), rgba(6, 11, 20, 0.98))",
            borderLeft: "0.01vw solid rgba(232, 78, 14, 0.28)",
            color: "#f3f5f8",
            boxShadow: "0 1.2vw 3vw rgba(0, 0, 0, 0.42)",
          },
        }}
      >
        <Box role="presentation" sx={{ py: 1 }}>
          <List
            aria-label={t("settings", "Configuración")}
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#f3f5f8",
                "& fieldset": {
                  borderColor: "rgba(232, 78, 14, 0.28)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(232, 78, 14, 0.5)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgba(232, 78, 14, 0.85)",
                },
              },
              "& .MuiInputLabel-root": {
                color: "rgba(255, 255, 255, 0.62)",
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#f3f5f8",
              },
              "& .MuiSelect-icon": {
                color: "#f3f5f8",
              },
              "& .MuiListSubheader-root": {
                bgcolor: "transparent",
                color: "rgba(255, 255, 255, 0.62)",
                fontSize: "0.72rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                lineHeight: 1.6,
                textTransform: "uppercase",
              },
              "& .MuiListItemButton-root": {
                minHeight: 46,
                color: "inherit",
                "&.is-active, &.active": {
                  backgroundColor: "rgba(232, 78, 14, 0.16)",
                },
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                },
              },
              "& .MuiListItemIcon-root": {
                minWidth: 42,
                color: "inherit",
                position: "relative",
              },
            }}
          >
            <ListItemButton
              onClick={handleSettingsAction(handleCalendarOpen)}
              aria-label={t("calendar", "Calendario")}
            >
              <ListItemIcon>
                <CalendarMonthRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={t("calendar", "Calendario")} />
            </ListItemButton>
            <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.12)", my: 0.75 }} />

            {isSuperuser && (
              <ListItemButton
                className={view === "insight" ? "is-active" : ""}
                onClick={handleSettingsAction(() => setView(view === "insight" ? "dashboard" : "insight"))}
                aria-label="ITG Insight"
              >
                <ListItemIcon>
                  <AutoFixHighRoundedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="ITG Insight" />
              </ListItemButton>
            )}

            {renderGroupHeader("analitica", t("scapp_nav_analytics", "Analítica"))}
            <Collapse in={openGroups.analitica} timeout="auto" unmountOnExit>
              <ListItemButton
                className={view === "dashboard" && !simpleView ? "is-active" : ""}
                onClick={handleSettingsAction(() => {
                  setView("dashboard");
                  setSimpleView(false);
                })}
                aria-label={t("general", "General")}
              >
                <ListItemIcon>
                  <DashboardRoundedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("general", "General")} />
              </ListItemButton>

              <ListItemButton
                className={view === "dashboard" && simpleView ? "is-active" : ""}
                onClick={handleSettingsAction(() => {
                  setSimpleView(view === "dashboard" ? !simpleView : true);
                  if (view !== "dashboard") setView("dashboard");
                })}
                aria-label={t("scapp_simplified", "Simplificada")}
              >
                <ListItemIcon>
                  <DashboardRoundedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("scapp_simplified", "Simplificada")} />
              </ListItemButton>

              {nivelSeleccionado === "centro" && (
                <ListItemButton
                  className={`scapp-action-primary ${view === "versus" ? "is-active" : ""}`}
                  onClick={handleSettingsAction(handleToggle)}
                  aria-label={
                    view === "dashboard" ? t("compare", "Comparar") : t("general", "Resumen")
                  }
                >
                  <ListItemIcon>
                    <CompareArrowsRoundedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      view === "dashboard" ? t("compare", "Comparar") : t("general", "Resumen")
                    }
                  />
                </ListItemButton>
              )}

              {nivelSeleccionado === "centro" && view === "versus" && (
                <ListItemButton
                  className={compareCount > 0 ? "has-selection" : ""}
                  onClick={handleSettingsAction(handleOpen)}
                  aria-label={t("select_items", "Seleccionar")}
                >
                  <ListItemIcon>
                    <ChecklistRoundedIcon fontSize="small" />
                    {compareCount > 0 && <span className="scapp-icon-badge">{compareCount}</span>}
                  </ListItemIcon>
                  <ListItemText primary={t("select_items", "Seleccionar")} />
                </ListItemButton>
              )}

              {(view === "dashboard" || (showRateToggle && !isComparisonView)) && (
                <>
                  <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.12)", my: 0.75, mx:'1.25vw' }} />
                  <Box
                    sx={{
                      px: 2,
                      py: 0.25,
                      color: "rgba(255, 255, 255, 0.62)",
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      lineHeight: 1.6,
                      textTransform: "uppercase",
                    }}
                  >
                    {t("scapp_view_settings", "Ajustes de vista")}
                  </Box>
                </>
              )}

              {view === "dashboard" && (
                <Tooltip
                  title={hasDepthData
                    ? ""
                    : t("analytics_depth_no_measurements", "No hay datos de profundidad en el período solicitado.")}
                  placement="left"
                >
                  <Box>
                    <ListItemButton
                      onClick={handleSettingsAction(() => setDepthAnalyticsOpen(true))}
                      disabled={!hasDepthData}
                      aria-label={t("analytics_depth_open", "Profundidad")}
                    >
                      <ListItemIcon>
                        <HeightRoundedIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={t("analytics_depth_open", "Profundidad")} />
                    </ListItemButton>
                  </Box>
                </Tooltip>
              )}

              {view === "dashboard" && (
                <ListItemButton
                  className={rangosOpen ? "is-active" : ""}
                  onClick={toggleRangos}
                  aria-label={
                    rangosOpen ? t("hide_ranges", "Ocultar rangos") : t("show_ranges", "Mostrar rangos")
                  }
                >
                  <ListItemIcon>
                    <SplitscreenRoundedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      rangosOpen ? t("hide_ranges", "Ocultar rangos") : t("show_ranges", "Mostrar rangos")
                    }
                  />
                </ListItemButton>
              )}

              {view === "dashboard" && nivelSeleccionado === "centro" && (
                <ListItemButton
                  className={compact ? "is-active" : ""}
                  onClick={onCompactClick}
                  aria-label={compact ? t("uncompact", "Descompactar") : t("compact", "Compactar")}
                >
                  <ListItemIcon>
                    <ViewCompactRoundedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={compact ? t("uncompact", "Descompactar") : t("compact", "Compactar")}
                  />
                </ListItemButton>
              )}

            </Collapse>

            {feederScoreAllowed && (
              <>
                {renderGroupHeader("metricas", t("scapp_nav_feeding_metrics", "Métricas de alimentación"))}
                <Collapse in={openGroups.metricas} timeout="auto" unmountOnExit>
                  <ListItemButton
                    className={view === "feederScore" ? "is-active" : ""}
                    onClick={handleSettingsAction(() => setView(view === "feederScore" ? "dashboard" : "feederScore"))}
                    aria-label={t("feeder_score_menu", "Puntaje de alimentación")}
                  >
                    <ListItemIcon>
                      <SetMealRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={t("feeder_score_menu", "Puntaje de alimentación")} />
                  </ListItemButton>

                  <ListItemButton
                    className={view === "alarmAttention" ? "is-active" : ""}
                    onClick={handleSettingsAction(() => setView(view === "alarmAttention" ? "dashboard" : "alarmAttention"))}
                    aria-label={t("alarm_attention_menu", "Atención a Alarmas")}
                  >
                    <ListItemIcon>
                      <NotificationImportantRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={t("alarm_attention_menu", "Atención a Alarmas")} />
                  </ListItemButton>
                </Collapse>
              </>
            )}

            {renderGroupHeader("tiempo", t("scapp_nav_time", "Tiempo"))}
            <Collapse in={openGroups.tiempo} timeout="auto" unmountOnExit>
              <Box
                sx={{
                  px: 2,
                  pt: 1,
                  pb: 0,
                  color: "rgba(255, 255, 255, 0.62)",
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  lineHeight: 1.6,
                  textTransform: "uppercase",
                }}
              >
                {t("time_resolution", "Resolución Temporal")}
              </Box>

              <ListItemButton
                className={groupMode === "day" ? "is-active" : ""}
                onClick={() => handleGroupModeChange("day")}
              >
                <ListItemIcon>
                  <CalendarMonthRoundedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("chart_day", "Día")} />
              </ListItemButton>

              <ListItemButton
                className={groupMode === "week" ? "is-active" : ""}
                onClick={() => handleGroupModeChange("week")}
              >
                <ListItemIcon>
                  <CalendarMonthRoundedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("week", "Semana")} />
              </ListItemButton>

              <ListItemButton
                className={groupMode === "month" ? "is-active" : ""}
                onClick={() => handleGroupModeChange("month")}
              >
                <ListItemIcon>
                  <CalendarMonthRoundedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("month", "Mes")} />
              </ListItemButton>

              <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.12)", my: 0.75, mx:'1.25vw' }} />

              <Box sx={{ px: 2, pt: 1, pb: 0.5 }}>
                <FormControl
                  fullWidth
                  size="small"
                >
                  <InputLabel id="fasting-resolution-label">
                    {t("fasting_resolution", "Resolución de ayuno")}
                  </InputLabel>
                  <Select
                    labelId="fasting-resolution-label"
                    value={fastingResolution}
                    label={t("fasting_resolution", "Resolución de ayuno")}
                    onChange={handleFastingResolutionChange}
                    aria-label={t("fasting_resolution", "Resolución de ayuno")}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: "#252525",
                          color: "#fff",
                          "& .MuiMenuItem-root:hover": {
                            backgroundColor: "#353535",
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="half_day">{t("half_day", "Medio día")}</MenuItem>
                    <MenuItem value="day">{t("chart_day", "Día")}</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.12)", my: 0.75, mx:'1.25vw' }} />

              <Box sx={{ px: 2, pt: 1, pb: 0.5 }}>
                <FormControl
                  fullWidth
                  size="small"
                >
                  <InputLabel id="ranking-period-label">
                    {t("select_period", "Periodo Mostrado")}
                  </InputLabel>
                  <Select
                    labelId="ranking-period-label"
                    value={rankingPeriodValue}
                    label={t("select_period", "Periodo Mostrado")}
                    onChange={handleRankingPeriodSelect}
                    aria-label={t("select_period", "Periodo Mostrado")}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: "#252525",
                          color: "#fff",
                          "& .MuiMenuItem-root:hover": {
                            backgroundColor: "#353535",
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="all">{t("todas", "Todas")}</MenuItem>
                    {rankingAvailableDays.map((day) => (
                      <MenuItem key={day} value={day}>
                        {day}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

            </Collapse>

            {showRateToggle && !isComparisonView && (
              <Box sx={{ px: 2, py: 2 }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="feeding-rate-label">{t('feeding_rate_title', 'Tasa de alimentación')}</InputLabel>
                  <Select
                    labelId="feeding-rate-label"
                    value={selectedRateKey}
                    label={t('feeding_rate_title', 'Tasa de alimentación')}
                    onChange={(event) => setSelectedRateKey(event.target.value)}
                    MenuProps={{ PaperProps: { sx: { bgcolor: '#252525', color: '#fff' } } }}
                  >
                    <MenuItem value="auto">{t('feeding_rate_auto', 'Automática')}</MenuItem>
                    {Object.entries(FEEDING_RATES).map(([key, rate]) => (
                      <MenuItem key={key} value={key} disabled={!availableRates.includes(key)}>
                        {key === 'tasa_pfm' ? `${t('feeding_rate_preference_pfm', 'PFM')} (PPM)` : rate.unit}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </List>
        </Box>
      </Drawer>

      <DepthAnalyticsDialog
        open={depthAnalyticsOpen}
        onClose={() => setDepthAnalyticsOpen(false)}
        jaulas={depthCages}
        preferredCage={jaulaSeleccionada}
        translate={translate}
      />
      <SelectorData {...selectorDataProps} />
      <TemporaryDrawer {...drawerProps} />
    </>
  );
};

export default React.memo(ScappAppbar);
